// extracted by css-extract-rspack-plugin
export default {"wizardFooter":"src-components-wizard-WizardFooter-module__wizardFooter-WunHOM","footerContent":"src-components-wizard-WizardFooter-module__footerContent-Ylq7Vl","footerActions":"src-components-wizard-WizardFooter-module__footerActions-dvQBaO","footerButton":"src-components-wizard-WizardFooter-module__footerButton-Tnn7un","primaryButton":"src-components-wizard-WizardFooter-module__primaryButton-AQ2dPn","deleteButton":"src-components-wizard-WizardFooter-module__deleteButton-huCdn6"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wizardFooter\":\"src-components-wizard-WizardFooter-module__wizardFooter-WunHOM\",\"footerContent\":\"src-components-wizard-WizardFooter-module__footerContent-Ylq7Vl\",\"footerActions\":\"src-components-wizard-WizardFooter-module__footerActions-dvQBaO\",\"footerButton\":\"src-components-wizard-WizardFooter-module__footerButton-Tnn7un\",\"primaryButton\":\"src-components-wizard-WizardFooter-module__primaryButton-AQ2dPn\",\"deleteButton\":\"src-components-wizard-WizardFooter-module__deleteButton-huCdn6\"}";
        // 1793732289364
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  